/**
 * External dependencies
 */
import React from 'react';
import { Box, Text, Heading } from '@towersystems/towersystems-design-system';
import classnames from 'classnames';

/**
 * Internal dependencies
 */

/**
 * Style dependencies
 */
import './styles.scss';

const Annotation = ({ title, description, className }) => {
    const classes = classnames('annotated-section__annotation', className);
    return (
        <Box className={classes}>
            <Box className='annotated-section__title'>
                <Heading level='2'>{title}</Heading>
            </Box>
            <Box className='annotated-section__description'>
                <p>
                    <Text size="small">{description}</Text>
                </p>
            </Box>
        </Box>
    );
};

export default Annotation;
